"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.PrefillsEstRentInnSuccessAnalyticsEvent = exports.PrefillsEstRentInnOverrideAnalyticsEvent = exports.PrefillsEstRentInnFallbackAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when valid rent data is successfully pre-filled into the form
 */
var PrefillsEstRentInnSuccessAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('prefills_est_rent_inn_success');
exports.PrefillsEstRentInnSuccessAnalyticsEvent = PrefillsEstRentInnSuccessAnalyticsEvent;
/**
 * Triggers when prefill fails and user sees manual entry fallback
 */
var PrefillsEstRentInnFallbackAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('prefills_est_rent_inn_fallback');
exports.PrefillsEstRentInnFallbackAnalyticsEvent = PrefillsEstRentInnFallbackAnalyticsEvent;
/**
 * Triggers when user manually edits a pre-filled rent amount
 */
var PrefillsEstRentInnOverrideAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('prefills_est_rent_inn_override');
exports.PrefillsEstRentInnOverrideAnalyticsEvent = PrefillsEstRentInnOverrideAnalyticsEvent;
